const initialState = {
  activeFilterGroup: '',
  queryParams: {
    category: null,
    filterTags: [],
    searchTags: [],
    searchTerm: '',
    size: 48,
    sortBy: '',
  },
  origin: undefined,
  searchRulesets: undefined,
  relevancyWeightings: undefined,
};

export default initialState;
